import React, { useEffect, useState } from 'react'
import { toast } from 'sonner';
import { PROFILE } from '../../statics/localStorage';
import { getApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { dateTimeConverter } from '../../utils/dateTimeConverter';
import TableComponent from '../../components/DataTable/TableComponent';
import Pagination from '../../components/Pagination/Pagination';
import { getMyProfile } from '../../api/api.global';

const ReferralTab = ({ settingData }) => {

    const profileData = PROFILE();
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    const onCopyCode = (code) => {
        navigator.clipboard.writeText("Hi👋 , here is my Attriva refer code - " + code);
        toast.success('Referral code copied to clipboard');
    }

    const onReferCodeApply = async () => {
        const referCode = document.getElementById('refer-code').value?.trim();
        if (referCode) {
            let postData = {
                referralCode: referCode
            }
            let resp = await postApi(postData, urlApi.applyReferCode);
            if (resp.responseCode === 200) {
                getMyProfile();
                toast.success('Referral code applied successfully');
            } else {
                toast.error(resp.message);
            }
        } else {
            toast.error('Please enter a referral code.');
            return;
        }
    };

    async function getList() {
        loadingShow();
        let url = `${urlApi.myReferredList}?page=${activePage}&limit=${perPage}&`;
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        getList();
        return () => { };
    }, []);

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const claimReward = async (referCode) => {
        loadingShow();
        let url = `${urlApi.claimReward}${referCode}`;
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            getList();
            toast.success(resp?.message);
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        { name: "Name", center: "true", selector: (row) => row?.name, cell: (row) => <p className='px-3'>{(row?.name)}</p> },
        {
            name: "Link Clicks", selector: (row) => row?.uniqueLinkClicks, grow: 0.4, cell: (row) => (
                <div className='py-2 px-4'>
                    {row?.uniqueLinkClicks || "0"}
                </div>
            )
        }, { name: "Date", center: "true", selector: (row) => row?.createdAt, cell: (row) => <p className='px-3'>{dateTimeConverter(row?.createdAt)}</p> },
        {
            name: "Rewards", center: "true", width: 'max-content', selector: (row) => row?.amountEarned, cell: (row) => (
                <button className='!bg-primary px-3 py-2 rounded-full text-white disabled:!bg-gray-500' disabled={row?.uniqueLinkClicks < 10000 || row?.completionStatus} onClick={() => claimReward(row?._id)} >{row?.completionStatus ? 'Claimed' : 'Claim'}</button>
            )
        }
    ];

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8">
                <div className="w-full">
                    <p className='mb-2'>Your Refer Code</p>
                    <div className='border-2 border-dashed border-primary rounded-lg px-4 py-2 flex items-center gap-2 !mb-1'>
                        <span className='font-semibold text-primary'>{profileData?.referralCode || "--"}</span>
                        <button className='ms-auto text-sm font-semibold !text-primary hover:bg-primary hover:!text-white rounded-lg px-3 py-1.5 transition-all' onClick={() => onCopyCode(profileData?.referralCode || "")}>Copy</button>
                    </div>
                    <p className='mb-3 text-xs font-light text-center text-orange-600 italic'>You will receive the reward amount after your friend has completed {settingData?.minReferralLinkClick} unique link clicks.</p>
                </div>
                <div className="w-full">
                    <p className='mb-2'>Enter Friends Referral code</p>
                    <div className='border-2 border-primary rounded-lg px-4 py-2 flex items-center gap-2'>
                        <input readOnly={profileData?.referredBy} defaultValue={profileData?.referredUserReferralCode || ""} type="text" className="bg-transparent w-full focus:outline-none h-full" placeholder="Enter Referral Code" id='refer-code' />
                        <button disabled={profileData?.referredBy} className='ms-auto text-sm font-semibold !text-primary hover:bg-primary hover:!text-white rounded-lg px-3 py-1.5 transition-all' onClick={() => onReferCodeApply()}>{profileData?.referredBy ? 'Joined' : 'Join'}</button>
                    </div>
                </div>
            </div>

            <div>
                <p className='text-[14px] font-bold mb-3 text-[var(--grey)] px-2'>My Referred List</p>

                <TableComponent
                    columns={columns}
                    data={tableData.data}
                    totalRows={tableData.totalCount}
                    isHeader={true}
                    isPagination={false}
                    paginationPerPage={perPage}
                    handlePageChange={(e) => handlePageChange(e)}
                    handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

                <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
            </div>
        </div>
    )
}

export default ReferralTab